import { render, staticRenderFns } from "./Prakerja.vue?vue&type=template&id=5b9ce9ca&scoped=true"
import script from "./Prakerja.vue?vue&type=script&lang=js"
export * from "./Prakerja.vue?vue&type=script&lang=js"
import style0 from "./prakerja.css?vue&type=style&index=0&id=5b9ce9ca&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ce9ca",
  null
  
)

export default component.exports